<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">
        <h2>省心记工记账后台管理系统</h2>
        <p>记工记账的好帮手</p>
      </div>
      
      <el-form :model="loginForm" :rules="rules" ref="loginForm" class="login-form">
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            prefix-icon="el-icon-user"
            placeholder="请输入用户名"
          />
        </el-form-item>
        
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            prefix-icon="el-icon-lock"
            placeholder="请输入密码"
            @keyup.enter.native="handleLogin"
          />
        </el-form-item>
        
        <el-form-item>
          <el-button
            type="primary"
            :loading="loading"
            @click="handleLogin"
            class="login-btn"
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    
    <div class="footer">
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=41020202001074" target="_blank" rel="nofollow">
        豫ICP备2026017049号-1
      </a>
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=41020202001074" rel="noreferrer" target="_blank">
        <img src="/images/beian.png" alt="备案" class="beian-icon" />
        豫公网安备41020202001074号
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: 'weijunliang',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          this.loading = true
          try {
            const res = await this.$http.post('/admin/login', this.loginForm)
            this.$store.dispatch('login', res)
            this.$message.success('登录成功')
            this.$router.push('/dashboard')
          } catch (error) {
            console.error(error)
          } finally {
            this.loading = false
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.login-box {
  width: 400px;
  padding: 40px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
  
  h2 {
    font-size: 24px;
    color: #333;
    margin-bottom: 10px;
  }
  
  p {
    font-size: 14px;
    color: #999;
  }
}

.login-form {
  .el-input {
    height: 44px;
    
    ::v-deep .el-input__inner {
      height: 44px;
      line-height: 44px;
    }
  }
}

.login-btn {
  width: 100%;
  height: 44px;
  font-size: 16px;
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 10px 0;
  
  a {
    display: flex;
    align-items: center;
    color: rgba(255, 255, 255, 0.7);
    font-size: 12px;
    text-decoration: none;
    
    &:hover {
      color: rgba(255, 255, 255, 0.9);
    }
  }
  
  .beian-icon {
    width: 14px;
    height: 14px;
    margin-right: 4px;
  }
}
</style>
